import React from 'react';

import { useIntl } from 'react-intl';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { Item, ItemName, ItemPrice, ItemQuantityBadge } from './cart-entry.styled';
import resolveEntryChild from './resolve-entry-child';

interface ICartEntry {
  entry: IBackendCartEntries;
  currencyFormatter: Function;
}

const CartEntry = ({ entry, currencyFormatter }: ICartEntry) => {
  const { formatMessage } = useIntl();

  return (
    <Item>
      <ItemQuantityBadge quantityText={formatMessage({ id: 'qty' })}>
        {entry.quantity || 1}
      </ItemQuantityBadge>
      <ItemName>{entry.name}</ItemName>
      {resolveEntryChild(entry, currencyFormatter)}
      <ItemPrice>
        <Currency amount={priceForCartEntry(entry)} />
      </ItemPrice>
    </Item>
  );
};

export default CartEntry;
